const ScrollLockUtil = {
	lock: function ($element) {
		if ($element.data("is-scroll-locked") !== true) {
			$element.data("scroll-locked-backup", $element.css("overflow"));
			$element.data("is-scroll-locked", true);
			$element.css("overflow", "hidden");
		}
	},

	unlock: function ($element) {
		$element.css("overflow", $element.data("scroll-locked-backup"));
		$element.data("is-scroll-locked", "");
		$element.data("scroll-locked-backup", null);
	},

	lockPage: function () {
		this.lock($("html"));
	},

	unlockPage: function () {
		this.unlock($("html"));
	}
};

export default ScrollLockUtil;
